/**
 * Guarda un PDF en el computador.
 * En Chrome y Edge abre el cuadro «Guardar como» ya ubicado en el Escritorio (una página web no puede elegir sola la carpeta de descargas).
 * En Safari, Firefox y en el celular no existe ese cuadro: se hace la descarga normal, que va a la carpeta de descargas del navegador.
 * El cuadro se abre ANTES de pedir el archivo al servidor, porque el navegador solo lo permite justo después de tocar el botón.
 */
export type ResultadoGuardado = "guardado" | "cancelado" | "descarga";

export async function guardarPdf(nombre: string, obtener: () => Promise<Blob>): Promise<ResultadoGuardado> {
  const w = window as unknown as { showSaveFilePicker?: (o: unknown) => Promise<{ createWritable: () => Promise<{ write: (b: Blob) => Promise<void>; close: () => Promise<void> }> }> };
  if (typeof w.showSaveFilePicker === "function" && window.isSecureContext && window.top === window) {
    let manejador: Awaited<ReturnType<NonNullable<typeof w.showSaveFilePicker>>> | null = null;
    try {
      manejador = await w.showSaveFilePicker({ suggestedName: nombre, startIn: "desktop", types: [{ description: "Documento PDF", accept: { "application/pdf": [".pdf"] } }] });
    } catch (e) {
      if (e instanceof DOMException && e.name === "AbortError") return "cancelado"; // la persona cerró el cuadro
      manejador = null; // el navegador no lo permitió: se usa la descarga normal
    }
    if (manejador) {
      const blob = await obtener();
      const f = await manejador.createWritable();
      await f.write(blob); await f.close();
      return "guardado";
    }
  }
  const blob = await obtener();
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url; a.download = nombre;
  document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 10000);
  return "descarga";
}
